import { render, staticRenderFns } from "./UserSensorEvents.vue?vue&type=template&id=38286af1&"
import script from "./UserSensorEvents.vue?vue&type=script&lang=js&"
export * from "./UserSensorEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports